export const expertise = [
  {
    name: "JavaScript",
    icon: "SiJavascript",
    color: "#F7DF1E"
  },
  {
    name: "TypeScript",
    icon: "SiTypescript",
    color: "#3178C6"
  },
  {
    name: "NodeJS",
    icon: "FaNodeJs",
    color: "#339933"
  },
  {
    name: "NestJS",
    icon: "SiNestjs",
    color: "#E0234E"
  },
  {
    name: "Express",
    icon: "SiExpress",
    color: "#000000"
  },
  {
    name: "Koa",
    icon: "SiKoa",
    color: "#33333D"
  },
  {
    name: "Angular",
    icon: "FaAngular",
    color: "#DD0031"
  },
  {
    name: "React",
    icon: "FaReact",
    color: "#61DAFB"
  },
  {
    name: "Vue",
    icon: "SiVuedotjs",
    color: "#4FC08D"
  },
  {
    name: "Vite",
    icon: "SiVite",
    color: "#646CFF"
  },
  {
    name: "Electron",
    icon: "SiElectron",
    color: "#47848F"
  },
  {
    name: "PostgreSQL",
    icon: "SiPostgresql",
    color: "#4169E1"
  },
  {
    name: "MySQL",
    icon: "SiMysql",
    color: "#4479A1"
  },
  {
    name: "MongoDB",
    icon: "SiMongodb",
    color: "#47A248"
  },
  {
    name: "Redis",
    icon: "SiRedis",
    color: "#DC382D"
  },
  {
    name: "Elastic",
    icon: "SiElasticsearch",
    color: "#005571"
  },
  {
    name: "TypeORM",
    icon: "SiTypescript",
    color: "#3178C6"
  },
  {
    name: "Sequelize",
    icon: "SiSequelize",
    color: "#52B0E7"
  },
  {
    name: "AWS",
    icon: "FaAws",
    color: "#FF9900"
  }
]; 